import { render, staticRenderFns } from "./mainBannerMenu.vue?vue&type=template&id=279f6287&scoped=true&"
import script from "./mainBannerMenu.vue?vue&type=script&lang=js&"
export * from "./mainBannerMenu.vue?vue&type=script&lang=js&"
import style0 from "./mainBannerMenu.vue?vue&type=style&index=0&id=279f6287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f6287",
  null
  
)

export default component.exports